import React, { Component } from 'react';
import {  MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBContainer } from 'mdbreact';

class Footer extends Component {
 
  render() {
    return (
      <footer>
      <p>Contacto <br/> 
      alonzo@wirelessalonzo.com.mx<br/>
       Oficina: 279 115 4708 &nbsp;&nbsp;&nbsp;
       Celular: 279 113 2425 &nbsp;&nbsp; <i className="fab fa-whatsapp"></i>&nbsp;&nbsp;
       <a href="https://www.facebook.com/Wireless-Alonzo-106516284316997/" >
         <i className="fab fa-facebook"></i></a>
      </p>
      <ul>
        <li><a  href="/aviso">Aviso de privacidad</a> </li>
      </ul>
      <ul>
      <li><a   href="/codigo" >Código de prácticas comerciales</a></li>
      </ul>
  </footer>
    );
  }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/footer2.js